
    import './DirectMessageApp.scss';
    import * as S from '../../scss/theme';
    import fnc from '../../mymod/commFunction';
    import HongButton from '../../comm/HongButton';
    import React, { useState, useEffect } from 'react';
    import { useNavigate } from 'react-router-dom';
    import { useDispatch, useSelector } from 'react-redux';
    import DirectMessageWindow from './DirectMessageWindow';
    import MyTreeView from "./MyTreeViewTec";
    import StuList from './StuList';

    const DirectMessageApp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [selectedNodeItem, setSelectedNodeItem] = useState(null);
    const [selectedStudents, setSelectedStudents] = useState([]);

    // StuList에서 선택된 학생들을 실시간으로 받기
    const handleStudentSelection = (students) => {
        setSelectedStudents(students);
    };

    // DirectMessageWindow에서 학생 제거 요청 받기
    const handleStudentRemove = (studentToRemove) => {
        console.log('학생 제거 요청:', studentToRemove.name);
        const updatedStudents = selectedStudents.filter(
            student => student.id !== studentToRemove.id
        );
        setSelectedStudents(updatedStudents);
    };

    useEffect(() => {
        // 초기화 작업이 필요하면 여기에 추가
    }, []);
    //=========================================
    return (
    <S.Section className="direct-message-section">
        <div className='DirectMessageApp'>
            <section className="sec-treeview">
                <MyTreeView setSelectedNodeItem={setSelectedNodeItem} />
            </section>


            <section className="sec-stuList">
                <StuList 
                    selectedNodeItem={selectedNodeItem} 
                    onStudentSelection={handleStudentSelection}
                    selectedStudents={selectedStudents}
                />
            </section>


            <section className="sec-chatwindow"> 
                <DirectMessageWindow 
                    selectedStudents={selectedStudents}
                    isOpen={true}
                    onClose={() => {}}
                    onStudentRemove={handleStudentRemove}
                />
            </section>

          

        </div>
    </S.Section>
    );
    };

    export default DirectMessageApp;